import type { Appointments } from "@/lib/appointments"

export const buildAppointmentsCacheKeys = ({
  practiceId,
  service,
  startTime,
}: Appointments.OfferingsCache.KeyData): Appointments.OfferingsCache.Keys => {
  const practiceIdKey = `practiceId:${practiceId}`

  return [`appointments`, service, practiceIdKey, startTime]
}
